<mat-form-field
  matTooltipClass="error-tooltip"
  appearance="outline"
  floatLabel="always"
  [matTooltip]="errorTooltip()"
  [matTooltipDisabled]="!touched()"
  class="lib-input coin-form-field-outline coin-form-field-outline--{{ matFormFieldClass }} no-margin">
  @if (label) {
    <mat-label>{{ label }}</mat-label>
  }
  <textarea
    matInput
    cdkTextareaAutosize
    autocomplete="off"
    [cdkAutosizeMinRows]="rows === 'auto' ? 1 : rows"
    [cdkAutosizeMaxRows]="rows === 'auto' ? 50 : rows"
    [placeholder]="placeholder"
    [attr.readonly]="disabled() ? true : null"
    [disabled]="disabled()"
    [(ngModel)]="value"
    (blur)="onTouch()"></textarea>
  @if (icon) {
    <mat-icon>{{ icon }}</mat-icon>
  }
</mat-form-field>
